function objectToQuery(object) {
    const query = new URLSearchParams();
    for (const key in object) {
        query.append(key, object[key]);
    }
    return query;
}

module.exports = objectToQuery